import React from 'react'
import Navbar from '../Components/Navbar'
import Banners from '../Components/Banners'
import Footers from '../Components/Footers'

const Home =() =>{
  return (
    <div>
      {/* <Navbar/> */}
      <Banners/>
    <Footers/>
      
    </div>
  )
}

export default Home